export default {
    'memberBenefit.title': 'สิทธิประโยชน์สมาชิก',
} as Record<string, string>;
